module.exports = __webpack_public_path__ + "img/flealover-sitelogo.80ab833b.png";